import React from 'react';

const useDialog = () => {
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return {
    openDialog,
    handleOpenDialog,
    handleCloseDialog
  };
};

export default useDialog;
